// extracted by mini-css-extract-plugin
module.exports = {"buttons":"SalesforcesCreateNewLeadModal_buttons__eNyuM","cancelButton":"SalesforcesCreateNewLeadModal_cancelButton__B0Fqq"};